import { render, staticRenderFns } from "./returnGoods.vue?vue&type=template&id=277bb1d1"
import script from "./returnGoods.vue?vue&type=script&lang=js"
export * from "./returnGoods.vue?vue&type=script&lang=js"
import style0 from "./returnGoods.vue?vue&type=style&index=0&id=277bb1d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports